namespace Areas.Dialogs.BudgetAccountCategory {
    "use strict";

    let accountId: number;
    let budgetItemLinkId: number;
    let glDataId: number;
    let originalAmount: number;
    let reasonText: string;

    export function getId() {
        return budgetItemLinkId;
    }

    export function getAccountID() {
        return accountId;
    }

    export function onNewGridRow(e: any) {
        e.data.correctiveReferenceId = budgetItemLinkId;
        e.data.accountId = accountId;
        e.data.glDataId = glDataId;
        e.data.isReclass = true;
    }

    export class ReclassifyLinkDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any) {
            super("ReclassifyLink",
                closeHandler,
                parameters,
                () => {

                    const form = $("#ReclassifyLinkForm").dxForm("instance");
                    const formData: any = form.option("formData");

                    formData.OriginalBudgetCategoryLk = parameters.data.budgetCategoryLk;
                    formData.OriginalBudgetAccountCategoryId = parameters.data.budgetAccountCategoryId;
                    formData.OriginalAmount = parameters.data.budgetItemLinkAmount;
                    formData.Difference = 0;
                    formData.BudgetItemLinkId = parameters.data.budgetItemLinkId;

                    accountId = parameters.data.accountId;

                    budgetItemLinkId = parameters.data.budgetItemLinkId;
                    glDataId = parameters.data.glDataId;
                    originalAmount = parameters.data.budgetItemLinkAmount;


                    form.option("formData", formData);
                });
        }

        protected cancel = (e: any) => {
            const dataGrid = $("#ReclassifyLinkGrid").dxDataGrid("instance");
            let dataIds: string;
            let rc = dataGrid.totalCount();
  
            for (var i = 0; i < rc; i++) {
                                
                if (i == 0) {
                    dataIds = dataGrid.getKeyByRowIndex(i).toString();
                } else {
                    dataIds = dataIds + ',' + dataGrid.getKeyByRowIndex(i).toString();
                }
                
            }
           

            var data = JSON.stringify(
                {
                    "DataIds": dataIds
                    
                });

            this.close(DialogResult.Cancel, data);
        }

        protected ok = (e: any) => {
            const form = $("#ReclassifyLinkForm").dxForm("instance");
            const result: any = form.validate();
            const formData: any = form.option("formData");

            const textBox: any = $(`#ReasonTextBox`).dxTextBox('instance');

            if (textBox.option("value") != "") {
                reasonText = textBox.option("value");
            } else {
                DevExpress.ui.notify("You must enter a reason", "warning", 2000);
                return;
            }

            const dataGrid = $("#ReclassifyLinkGrid").dxDataGrid("instance");
            let amountTotal = dataGrid.getTotalSummaryValue("amountTotal")
            if (amountTotal != originalAmount) {
                DevExpress.ui.notify("New Lines must Total Original Amount", "warning", 2000);
                return
            }
            let dataIds: string;
            let rc = dataGrid.totalCount();

            for (var i = 0; i < rc; i++) {

                if (i == 0) {
                    dataIds = dataGrid.getKeyByRowIndex(i).toString();
                } else {
                    dataIds = dataIds + ',' + dataGrid.getKeyByRowIndex(i).toString();
                }

            }

            let isSplit = false;
            if (rc > 1) {
                isSplit = true;
            }

            var data = JSON.stringify(
                {
                    "DataIds": dataIds,
                    "ReasonText": reasonText,
                    "OriginalId": formData.BudgetItemLinkId,
                    "IsSplit": isSplit
                });

            this.close(DialogResult.Ok, data);
        }


    }




    


}
